export const defaultTinyMceConfig = {
	plugins: ['link', 'lists', 'code'],
	toolbar: 'undo redo | blocks | bold italic | numlist bullist | link',
	promotion: false,
	skin: false,
	height: 300,
	language: 'de',
}
